export enum BackendRoute {
  Api = 'api/v1',
  Image = 'images',
}
